import { inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { DialogOptions } from '@lib/util';

import { UploadZoneComponent } from '@lib/upload-zone/feature';
import { IFileUploadMaxSize } from '@lib/upload-zone/ui';

@Injectable({ providedIn: 'root' })
export class BasketDialogService {
    dialog = inject(MatDialog);

    openUploadZoneDialog(maxFileSize: IFileUploadMaxSize): Observable<any> {
        const options = DialogOptions.MEDIUM();
        options.disableClose = true;
        options.data = maxFileSize.binaryBytes;
        const dialogRef = this.dialog.open(UploadZoneComponent, options);
        return dialogRef.afterClosed();
    }
}
